import React from "react";
import "./App.scss";
import { Steps, Step } from "react-step-builder";
import StepOne from "./components/StepOne/StepOne";
import StepTwo from "./components/StepTwo/StepTwo";
import StepThree from "./components/StepThree/StepThree";
import StepFour from "./components/StepFour/StepFour";
import StepFive from "./components/StepFive/StepFive";
import StepSix from "./components/StepSix/StepSix";
import StepSeven from "./components/StepSeven/StepSeven";
import StepEight from "./components/StepEight/StepEight";
import StepNine from "./components/StepNine/StepNine";


import SquareContextProvider from "./SquareContext"
import ShapeContextProvider from "./ShapeContext"

function App() {
  return (
    <div className="App">
      <SquareContextProvider>
      <ShapeContextProvider>
      <Steps>
        <Step title="First"component={StepOne} />
        <Step component={StepTwo} />
        <Step title="Third" component={StepThree} />
        <Step component={StepFour} />
        
        <Step component={StepFive} />
        
        <Step component={StepSix} />
        <Step component={StepSeven} />
        <Step component={StepEight} />
        <Step component={StepNine} />
      
      </Steps>
      </ShapeContextProvider>
      </SquareContextProvider>
    </div>
  );
}

export default App;
